var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseLineInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 22.7501H24.5V12.6384C24.5 12.3962 24.4498 12.1566 24.3525 11.9348C24.2551 11.713 24.1128 11.5139 23.9345 11.3499L15.1845 3.09431C15.1803 3.09058 15.1762 3.08656 15.1725 3.08228C14.8503 2.7893 14.4305 2.62695 13.9951 2.62695C13.5596 2.62695 13.1398 2.7893 12.8177 3.08228L12.8056 3.09431L4.06547 11.3499C3.88719 11.5139 3.74487 11.713 3.64754 11.9348C3.5502 12.1566 3.49996 12.3962 3.5 12.6384V22.7501H1.75C1.51794 22.7501 1.29538 22.8423 1.13128 23.0064C0.967187 23.1705 0.875 23.393 0.875 23.6251C0.875 23.8572 0.967187 24.0797 1.13128 24.2438C1.29538 24.4079 1.51794 24.5001 1.75 24.5001H26.25C26.4821 24.5001 26.7046 24.4079 26.8687 24.2438C27.0328 24.0797 27.125 23.8572 27.125 23.6251C27.125 23.393 27.0328 23.1705 26.8687 23.0064C26.7046 22.8423 26.4821 22.7501 26.25 22.7501ZM5.25 12.6384L5.26203 12.6274L14 4.37509L22.7391 12.6252L22.7511 12.6362V22.7501H17.5V17.5001C17.5 17.036 17.3156 16.5908 16.9874 16.2627C16.6592 15.9345 16.2141 15.7501 15.75 15.7501H12.25C11.7859 15.7501 11.3408 15.9345 11.0126 16.2627C10.6844 16.5908 10.5 17.036 10.5 17.5001V22.7501H5.25V12.6384ZM15.75 22.7501H12.25V17.5001H15.75V22.7501Z",
    fill: "#C7C7CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseLineInactive);
export default __webpack_public_path__ + "static/media/HouseLineInactive.36e68cd88ecd974371c96ed70958ac72.svg";
export { ForwardRef as ReactComponent };